const config: PageConfigurationType = {
    breadCrumbs: [{ label: 'home', path: 'home' }, 'services_list']
}

export default config
